import { SkeletonText } from '@billy/design-system'
import styled from '@emotion/styled'

export const BillLineWrapper = styled.div``

export const SkeletonTextRightAligned = styled(SkeletonText)`
  margin-left: auto;
`
